import axios from 'axios';
import Vue from 'vue';
import Errors from '../classes/errors';
import { setCaptchaEuScript } from '../utils';

Vue.component('brochure-block-component', {
    props: {
        siteHandle: {
            type: String,
        },
        sharpspringBaseUrl: {
            value: String,
        },
        sharpspringEndpointId: {
            value: String,
        },
        sharpspringScriptUrl: {
            value: String,
        },
        captchaEuPublicKey: {
            value: String,
        },
        isCaptchaEuEnabled: {
            value: Boolean,
        },
    },
    data() {
        return {
            errors: new Errors(),
            isModalOpen: false,
            isCheckboxChecked: false,
            submitting: false,
            modelName: '',
            assetUrl: null,

            beLuxModels: {
                'mg-hs-phev': 'mg-ehs-2024',
                'mg-hs': 'mg-hs-2024',
            },
        };
    },

    computed: {
        parseModelName() {
            if (
                this.siteHandle === 'mgMotorsBelgiumNl' ||
                this.siteHandle === 'mgMotorsBelgiumFr'
            ) {
                return this.beLuxModels[this.modelName] || this.modelName;
            }

            if (this.modelName.includes('mg3')) return 'mg3';
            return this.modelName;
        },
    },

    watch: {
        modelName: function (newModel) {
            if (!Boolean(newModel.length)) return;
            this.handleLoadSharpsringScriptUrl();
            this.handleSetSharpspringScript();
        },
    },

    mounted() {
        setCaptchaEuScript();
    },

    methods: {
        handleSetSharpspringScript() {
            if (
                this.siteHandle !== 'mgMotorsBelgiumNl' &&
                this.siteHandle !== 'mgMotorsBelgiumFr'
            )
                return;
            const shaprspringScript = document.createElement('script');
            shaprspringScript.innerHTML = `
              var __ss_noform = __ss_noform || [];
              __ss_noform.push(['baseURI', \`${this.sharpspringBaseUrl}\`]);
              __ss_noform.push(['form', 'brochureForm-${this.modelName}', \`${this.sharpspringEndpointId}\`]);
              __ss_noform.push(['submitType', 'manual']);
            `;
            shaprspringScript.setAttribute(
                'id',
                `brochure-sharpspring-script-${this.modelName}`,
            );
            document.body.appendChild(shaprspringScript);
        },

        handleLoadSharpsringScriptUrl() {
            if (
                this.siteHandle !== 'mgMotorsBelgiumNl' &&
                this.siteHandle !== 'mgMotorsBelgiumFr'
            )
                return;
            const shaprspringScript = document.createElement('script');
            shaprspringScript.setAttribute('src', this.sharpspringScriptUrl);
            shaprspringScript.setAttribute(
                'id',
                `brochure-sharpspring-script-src-${this.modelName}`,
            );
            document.body.appendChild(shaprspringScript);
        },

        // Destroying a script because we don't want sharpspring
        // scripts to append indefinitely.
        handleDestroySharpspringScriptUrl() {
            const sharpspringScript = document.getElementById(
                `brochure-sharpspring-script-${this.modelName}`,
            );
            const sharpspringScriptSrc = document.getElementById(
                `brochure-sharpspring-script-src-${this.modelName}`,
            );

            if (!sharpspringScript && !sharpspringScriptSrc) return;
            document.body.removeChild(sharpspringScript);
            document.body.removeChild(sharpspringScriptSrc);
        },

        handleOpenModal(url, modelName) {
            this.isModalOpen = true;
            this.assetUrl = url;
            this.modelName = modelName;
        },

        handleCloseModal() {
            this.handleDestroySharpspringScriptUrl();
            this.assetUrl = null;
            this.modelName = '';
            this.isModalOpen = false;
            this.submitting = false;
        },

        handleCheckboxChecked(e) {
            this.isCheckboxChecked = e.target.checked;
            const marketingInput = document.querySelector('#marketing');

            if (!marketingInput) return;
            marketingInput.setAttribute(
                'value',
                this.isCheckboxChecked ? '1' : '0',
            );
        },

        handleFileDownload() {
            const link = document.createElement('a');
            link.href = this.assetUrl;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;

            if (this.submitting) return;

            this.submitting = true;

            try {
                if (!this.isCaptchaEuEnabled) {
                    await this.handleDataSubmit(form);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(form, captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, captchaSolution) {
            try {
                const formData = new FormData(form);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const response = await axios.post('/', formData);
                const result = response.data;

                // Handle form errors.
                if (result.data.errors) {
                    this.errors.clear();
                    this.errors.record(result.data.errors);
                    this.submitting = false;
                    return;
                }

                // Only Benelux countries
                if (
                    this.siteHandle === 'mgMotorsBelgiumNl' ||
                    this.siteHandle === 'mgMotorsBelgiumFr'
                ) {
                    window.__ss_noform.push([
                        'submit',
                        null,
                        this.sharpspringEndpointId,
                    ]);
                }

                this.handleFileDownload();
                this.handleCloseModal();
            } catch (e) {
                throw new Error(e);
            }
        },
    },
});
